
import * as slider from '@/js/slider.js';
import '@/css/app.pcss';
/* import * as maps from '@/js/maps.js'; */

document.addEventListener("DOMContentLoaded", function () {
    console.log(`
        ███████╗██╗   ██╗
        ██╔════╝██║   ██║
        ███████╗██║   ██║
        ╚════██║╚██╗ ██╔╝
        ███████║ ╚████╔╝ 
        ╚══════╝  ╚═══╝  
        `);
    });